/*
 * 戒导航 · 下载中心 —— 体积格式化（P7c，兜底工具）
 * =============================================================================
 * 设计依据：doc/知识库与文件下载中心设计方案.md §7.2（P7.3 列规范「大小格式」）。
 *
 * ★ 主口径由后端提供 `sizeText`（DownloadDataController::humanSize()，
 *   口径完全对齐 fof/upload 的 File::human_filesize()：B/kB/MB… 1024 进制）。
 *   本文件仅作**前端兜底**：当后端未给 sizeText 而只给了 sizeBytes 时使用，
 *   保证体积列始终有值、且与后端显示口径一致，不会出现两套单位。
 */

/** 单位序列（与后端 humanSize() 一致）。 */
const UNITS = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

/**
 * 字节 → 人类可读体积（1024 进制，口径同后端 / fof/upload）。
 *
 * @param bytes    字节数（可为 null/undefined，视为 0）
 * @param decimals 小数位（默认 0，与后端默认一致）
 * @returns        如 '12MB'；字节数 <= 0 时返回空串（前端显示占位）
 */
export function formatSize(bytes, decimals) {
  if (decimals === void 0) {
    decimals = 0;
  }
  const n = Number(bytes ?? 0);
  if (!isFinite(n) || n <= 0) return '';

  // 与后端一致的量级判定：floor((位数 - 1) / 3)
  const factor = Math.min(Math.max(0, Math.floor((String(Math.floor(n)).length - 1) / 3)), UNITS.length - 1);
  return (n / Math.pow(1024, factor)).toFixed(decimals) + UNITS[factor];
}
flarum.reg.add('jiedh-downloads', 'forum/utils/formatSize', { formatSize: formatSize, });